export default {
    currentLocaleValue: navigator.language.split('-')[0] || 'en' ,
    searchTerm: '',
    currentApplication: {},
    currentApplicationTab: parseInt(sessionStorage.getItem('currentTab')),
    currentInstance: null,
    displaySnackbar: false,
    snackbar: {
        color: '',
        icon: '',
        text: '',
    },
    ww: 0,
    datamodelDetailedError: {
        'WRONG_VERSION': null,
        'MISSING_KEY': null,
        'MISSING_RELATION': null,
        'DUPLICATED_RELATION': null,
        'MISSING_QUERIES': null,
        'MISSING_PERMISSIONS': null,
        'DUPLICATED_QUERIES': null,
        'DUPLICATED_PERMISSIONS': null,
        'DUPLICATED_FIELDS': null,
        'DUPLICATED_REVERSE': null,
        'NAME_NOT_ALLOWED': null,
        'UNKNOWN_DATATYPE': null,
        'FIELD_NAME_NOT_ALLOWED': null,
        'MODEL_NAME_NOT_ALLOWED': null,
        'UNKNOWN_ERROR': null,
    },
    modelsWithError: [],
    saveState: 'upToDate', // possible values readOnly, error, sync, unsaved, upToDate
    freeVersion : window.config.free_version,
    concreteSite: window.config.concrete_site
};



// WEBPACK FOOTER //
// ./src/store/state.js